import {useEffect} from 'react';

import {QueryParamsForTaggingEnum} from 'presentation/constants';
import {useQueryParams} from 'presentation/pages/private/hooks';

interface UseQueryParamsSyncProps {
	step: number;
	protocol?: string;
}

export function useQueryParamsSync({step, protocol}: UseQueryParamsSyncProps) {
	const {setSearchParams} = useQueryParams();

	useEffect(() => {
		setSearchParams(
			prev => {
				prev.set(
					QueryParamsForTaggingEnum.REQUEST_PREVIEW_REFUND_STEP,
					(step + 1).toString(),
				);

				if (protocol) {
					prev.set(
						QueryParamsForTaggingEnum.REQUEST_PREVIEW_REFUND_PROTOCOL_NUMBER,
						protocol,
					);
				} else {
					prev.delete(QueryParamsForTaggingEnum.REQUEST_PREVIEW_REFUND_PROTOCOL_NUMBER);
				}

				return prev;
			},
			{
				replace: true,
			},
		);
	}, [step, protocol, setSearchParams]);

	return {
		step,
		setSearchParams,
	};
}
